export const storeName = 'powerReviews';

export default {
    SET_SETTINGS: `${storeName}.SET_SETTINGS`,
    INSTALL_REVIEWLIST: `${storeName}.INSTALL_REVIEWLIST`,
    INSTALL_FORM: `${storeName}.INSTALL_FORM`,
    SET_INITIALIZED: `${storeName}.SET_INITIALIZED`,
};
